export const FONT_COLOR_KEY = "fontColor";
export const FONT_BACKGROUND_COLOR_KEY = "fontBackgroundColor";
export const FONT_COLOR_CLASS_PREFIX = "ck-font-color-";
export const FONT_BACKGROUND_COLOR_CLASS_PREFIX = "ck-font-background-color-";

export const FONT_COLORS = [
  {
    color: "var(--ck-palette__font-color--1)",
    label: " ",
  },
  {
    color: "var(--ck-palette__font-color--2)",
    label: " ",
  },
  {
    color: "var(--ck-palette__font-color--3)",
    label: " ",
  },
  {
    color: "var(--ck-palette__font-color--4)",
    label: " ",
  },
  {
    color: "var(--ck-palette__font-color--5)",
    label: " ",
  },
  {
    color: "var(--ck-palette__font-color--6)",
    label: " ",
  },
  {
    color: "var(--ck-palette__font-color--7)",
    label: " ",
  },
  {
    color: "var(--ck-palette__font-color--8)",
    label: " ",
  },
];

export const FONT_BACKGROUND_COLORS = [
  {
    color: "var(--ck-palette__background--1)",
    label: " ",
  },
  {
    color: "var(--ck-palette__background--2)",
    label: " ",
  },
  {
    color: "var(--ck-palette__background--3)",
    label: " ",
  },
  {
    color: "var(--ck-palette__background--4)",
    label: " ",
  },
  {
    color: "var(--ck-palette__background--5)",
    label: " ",
  },
  {
    color: "var(--ck-palette__background--6)",
    label: " ",
  },
  {
    color: "var(--ck-palette__background--7)",
    label: " ",
  },
  {
    color: "var(--ck-palette__background--8)",
    label: " ",
  },
];

export const FONT_COLOR_CLASSES = FONT_COLORS.map((color, index) => `${FONT_COLOR_CLASS_PREFIX}${index}`);

export const FONT_BACKGROUND_COLOR_CLASSES = FONT_BACKGROUND_COLORS.map(
  (color, index) => `${FONT_BACKGROUND_COLOR_CLASS_PREFIX}${index}`
);

export const FONT_COLOR_CLASSES_MAP = {
  [FONT_COLOR_KEY]: FONT_COLOR_CLASSES,
  [FONT_BACKGROUND_COLOR_KEY]: FONT_BACKGROUND_COLOR_CLASSES,
};
